import { KeyboardShortcuts, KeyboardShortcutsDefaults } from "@sal/portal";

export const keyboardShortcuts: KeyboardShortcuts = {
	...KeyboardShortcutsDefaults,
	"Bookings.FocusSearch": {
		keyCombination: "mod+f",
		keyCombinationDisplay: "Ctrl+F",
		descriptionHelp: "Focus the bookings search box.",
		options: { preventDefault: true }
	},
	// react-hotkeys-hook matches normalised event.code, so "/" must be bound as "slash".
	"Bookings.QuickFocusSearch": {
		keyCombination: "slash",
		keyCombinationDisplay: "/",
		descriptionHelp: "Focus the bookings search box.",
		options: { preventDefault: true }
	}
};
